
import { useMemo } from "react";

export const useChannelsFormatter = (channelsData: any[] | undefined) => {
  const formattedChannels = useMemo(() => {
    return (channelsData || []).map(channel => ({
      id: channel.id,
      name: channel.name,
      thumbnailUrl: channel.thumbnail,
      logoLight: channel.logo_light || channel.logo,
      logoDark: channel.logo_dark || channel.logo
    }));
  }, [channelsData]);

  return formattedChannels;
};
